"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var query_string_1 = require("./query-string");
var getShareableLink = function (url, params) {
    if (params === void 0) { params = {}; }
    var _a = tslib_1.__read(url.split('?'), 2), host = _a[0], _b = _a[1], queryAndHash = _b === void 0 ? '' : _b;
    var _c = tslib_1.__read(queryAndHash.split('#'), 2), _d = _c[0], query = _d === void 0 ? '' : _d, _e = _c[1], hash = _e === void 0 ? '' : _e;
    var queryParams = (0, query_string_1.parse)(query);
    // remove all wix-vod-* params from url
    (0, lodash_1.forEach)(queryParams, function (value, key) {
        if (/wix-vod/.test(key)) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete queryParams[key];
        }
    });
    // convert safe params to string
    var queryString = (0, query_string_1.stringify)(tslib_1.__assign(tslib_1.__assign({}, queryParams), params));
    var hashEnd = hash.length ? "#".concat(hash) : '';
    return "".concat(host).concat(queryString).concat(hashEnd);
};
var getUrlToWidget = function (siteUrl, compId, params) {
    if (params === void 0) { params = {}; }
    if (compId) {
        params['wix-vod-comp-id'] = compId;
    }
    return getShareableLink(siteUrl, params);
};
exports.default = getUrlToWidget;
//# sourceMappingURL=get-url-to-widget.js.map